/**
 * How the Gallery's polls behave when a read fails.
 *
 * A poll stops only on an answer, so retrying every failure at its own pace
 * kept it going for as long as the network was down — every 400ms for a
 * solve. And once signed out every read is a 401, each one signing out again.
 */
// The longest a failing poll waits between reads.
const POLL_MAX_BACKOFF_MS = 30_000;
/** The wait before the next read: the poll's own interval, doubled per failure in a row. */
export const pollDelay = (intervalMs, failures) => Math.min(intervalMs * 2 ** failures, POLL_MAX_BACKOFF_MS);
/** Signed out (or never signed in): no later read will answer, so the poll stops. */
export const isUnauthorized = (error) => error?.response
    ?.status === 401;
//# sourceMappingURL=poll.js.map